// The reference build decides hero autoplay in React via matchMedia. PHP
// cannot see that, so the markup ships without an autoplay attribute and
// playback starts here instead. A blocked or broken bundle therefore leaves
// the poster over the blueprint gradient — the same "fail to the safe,
// legible state" rule the header and reveal gates follow.
//
// querySelectorAll, not querySelector: nothing stops an editor placing a
// second hero-video block on a page (a landing page with a video band lower
// down, say), and the single-element form left every hero after the first
// permanently paused on its poster.
export default function initHeroVideo() {
    const videos = document.querySelectorAll('[data-awdd-hero-video]');
    if (!videos.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    videos.forEach((video) => {
        video.preload = 'auto';
        video.play().catch(() => {
            // Autoplay refused (some mobile power-saving modes). The poster stays.
        });
    });
}
